module.exports = __webpack_public_path__ + "static/media/img3.4a813c63.jpeg";